<template>
  <div>
    <router-view name="createTag" />
    <router-view name="editTag" />
    <router-view />
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
</style>
